<template lang="html">

 <li class="keyword to-select" @click="sendData">
  <div class="contenedor-keyword">
    <label>{{data}}</label>
  </div>
</li>

</template>

<script lang="js">
  export default  {
    name: 'keyword-to-select',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      sendData : function(){
        this.$emit('click');
      }
    },
    computed: {

    }
  }
</script>

<style scoped>

.filtro-despl .contenedor-check{
  margin-top: 0;
}


li.keyword{
  width: auto;
  cursor: pointer;
}

.keyword label{
  padding: 0;
  width: 100%;
  height: auto;
  line-height: 1.3em;
  padding: 10px 10px;
  cursor: pointer;
}

.keyword input:checked + label{
  border: 1px solid #054279;
}

.keyword input:checked + label::before{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/keyword-to-select.vue